import { useMemo } from 'react';
import { token } from '@atlaskit/tokens';
import { usePlan } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/plan/index.tsx';
import type { NavigationTheme } from '@atlassian/jira-navigation-apps-sidebar-common/src/types.tsx';

const menuItemActiveHoverColor = token('color.background.selected');

const getTheme = (activeColor: string) => ({
	navigation: {
		item: {
			background: {
				default: 'transparent',
				active: menuItemActiveHoverColor,
				hover: menuItemActiveHoverColor,
			},
			color: {
				active: activeColor,
			},
		},
	},
});

export const useTheme = (): NavigationTheme | undefined => {
	const { data } = usePlan();
	const isMultiScenarioEnabled = data?.isMultiScenarioEnabled;

	const theme = useMemo(() => {
		if (isMultiScenarioEnabled == null) {
			return undefined;
		}

		return getTheme(token('color.text.selected'));
	}, [isMultiScenarioEnabled]);

	return theme;
};
